<ng-template [ngTemplateOutlet]="getSizeTemplate(imageSize)" class="cap-logo"></ng-template>

<ng-template #default>
  <div class="cap-logo">
    <img alt="{{ 'Logo ' + ('layouts.page.title' | translate) }}" height="150" src="{{ imagePath }}" style="margin: 10px" width="150" />
    <div id="home-logo-default-text">
      <h3>{{ "shared.logo.grundstueckInformationen" | translate }}</h3>
      <h3>{{ "layouts.page.title" | translate }}</h3>
    </div>
  </div>
</ng-template>

<ng-template #large>
  <div class="cap-logo">
    <img
      alt="{{ 'Logo ' + ('layouts.page.title' | translate) }}"
      class="cap-logo"
      height="354"
      src="{{ imagePath }}"
      style="margin: 10px"
      width="400" />
    <br />
    <div id="home-logo-large-text">
      <h3>{{ ("shared.logo.grundstueckInformationen" | translate) + " " + ("layouts.page.title" | translate) }}</h3>
    </div>
  </div>
</ng-template>
